import { createReducerContext } from '../../../../utils/create-reducer-context';
import { DashboardState, DashboardReducer, ACTION_TYPES } from './dashboard-reducer';

const initialState: DashboardState = { loading: false, upcomingDays: 30 };

const { Provider: DashboardProvider, useStateContext: useDashboardState, useDispatchContext: useDashboardDispatch } = createReducerContext('Dashboard', DashboardReducer, initialState);

export { DashboardProvider, useDashboardState, useDashboardDispatch, ACTION_TYPES };
